import { normalizeWebsiteLocationKind } from "./locationKindUtils"

type BuilderLocation = {
  kind?: unknown
  city?: string
  stateAbbreviation?: string
  state?: string
  state_abbreviation?: string
}

type BuilderServiceItem = {
  virtual?: boolean
  atHome?: boolean
  at_home?: boolean
  locations?: BuilderLocation[]
}

function hasInPersonLocation(locations: BuilderLocation[]): boolean {
  return locations.some((loc) => {
    const kind = normalizeWebsiteLocationKind(loc.kind)
    return kind === "office" || kind === "physical"
  })
}

/** Location / modality label for service/package rows in builder pickers. */
export function getBuilderServiceItemLocationDetail(item: BuilderServiceItem | null | undefined): string {
  if (!item) return ""

  const locations = item.locations || []
  const kinds = locations.map((loc) => normalizeWebsiteLocationKind(loc.kind))
  const hasVirtual = Boolean(item.virtual) || kinds.includes("virtual")
  const hasInPerson = hasInPersonLocation(locations)
  const hasAtHome = Boolean(item.atHome || item.at_home) || kinds.includes("home")

  if (hasVirtual && !hasInPerson && !hasAtHome) {
    return "Virtual"
  }

  if (hasAtHome && !hasInPerson) {
    return "At your home"
  }

  const officeLocations = locations.filter((loc) => {
    const kind = normalizeWebsiteLocationKind(loc.kind)
    return kind === "office" || kind === "physical"
  })

  if (officeLocations.length > 1) {
    return "Multiple Locations"
  }

  const singleOffice = officeLocations.length === 1 ? officeLocations[0] : undefined
  if (singleOffice) {
    const state = singleOffice.stateAbbreviation ?? singleOffice.state_abbreviation ?? singleOffice.state
    if (singleOffice.city && state) {
      return `${singleOffice.city}, ${state}`
    }
    return singleOffice.city || ""
  }

  return ""
}
